import { computed } from 'vue';

import { setSpaces } from '@/config/spaces';
import { getCookie } from '@/helpers/cookies';
import { useAuthStore } from '@/stores/auth';
import { useGlobalStore } from '@/stores/global';

type RoleState = 'noScopes' | 'noCookies' | 'validSpaces' | 'invalidSpaces' | 'isManager';

export const userSpaces = computed(() => getCookie('user_spaces'));
export const roleSpaces = computed(() => getCookie('role_spaces'));
export const companySpaces = computed(() => getCookie('company_spaces'));

export function getSpacesRole(): RoleState {
  const authStore = useAuthStore();
  const globalStore = useGlobalStore();
  const recruiterOnly = computed(
    () => authStore.hasPermission('recruiter_r') && !authStore.hasPermission('company_admin_r')
  );

  if (recruiterOnly.value) {
    return 'noScopes';
  } else if (!roleSpaces.value || userSpaces.value !== authStore.user.uuid) {
    // Set auto cookies for dev env, avoid launch auth app in parallel
    if (globalStore.getAutoCookieSpaces && globalStore.environment === 'dev') {
      setSpaces();
      if (authStore.hasPermission('manager_r')) {
        return 'isManager';
      } else return 'validSpaces';
    }
    return 'noCookies';
  } else if (authStore.hasPermission('recruiter_r') && roleSpaces.value !== 'recruiter') {
    return 'invalidSpaces';
  } else if (authStore.hasPermission('manager_r') && globalStore.environment === 'dev') {
    return 'isManager';
  } else return 'validSpaces';
}

export function redirectToSpaces() {
  window.location.assign(
    `${useGlobalStore()?.auth_url}/spaces?role=${roleSpaces.value}&company=${companySpaces.value}&from=${
      window.location.href
    }`
  );
}
